import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { LocalStorageKeys } from 'src/app/shared/models/constants/storage.keys';
import { BannerResponseDTO } from 'src/app/shared/models/dtos/responses/banner-response-dto/banner-response-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-banner-notification',
  templateUrl: './banner-notification.component.html',
  styleUrls: ['./banner-notification.component.scss'],
})

/**
 * Banner Notification Component
 */
export class BannerNotificationComponent implements OnInit, OnDestroy {
  @Input() icon!: string;
  labels = {
    learnMore: 'learn-more',
    bannerText: 'banner-notification-text',
  };
  RoutesKeys = RoutesKeys;
  private subsink = new Subscription();
  loading = false;
  language = '';
  bannerInfo!: BannerResponseDTO | undefined;

  /**
   * @constructor
   */
  constructor(
    readonly translationService: TranslationService,
    private readonly dialogService: DialogService,
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
    this.translationService.translateObject(this.labels);

    this.bannerInfo = this.authenticatedUserService.bannerData;

    if (
      this.bannerInfo?.showBanner &&
      this.bannerInfo.startDate &&
      this.bannerInfo.endDate
    ) {
      const currentCampaignId = this.getCampaignId(this.bannerInfo);
      const lastSeenCampaignId = localStorage.getItem(LocalStorageKeys.BANNER);

      if (lastSeenCampaignId !== currentCampaignId) {
        this.openLearnMoreModal(this.bannerInfo);
        this.bannerSeen(currentCampaignId);
      }
    }
  }

  /**
   * cleans up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Opens Modal
   * @param {BannerResponseDTO} banner
   */
  openLearnMoreModal(banner: BannerResponseDTO) {
    this.dialogService.openNoticeModal(banner);
  }

  /**
   * Set local storage after first login after banner
   * @param {string} campaignId
   */
  bannerSeen(campaignId: string) {
    localStorage.setItem(LocalStorageKeys.BANNER, campaignId);
  }

  /**
   * @param {BannerResponseDTO} banner
   * @return {string}
   */
  private getCampaignId(banner: BannerResponseDTO): string {
    const startMs = new Date(banner.startDate!).getTime();
    const endMs = new Date(banner.endDate!).getTime();
    return `${startMs}_${endMs}`;
  }
}
